export default __webpack_public_path__ + "static/media/IBimageAnklestiffness2.5e4ac11b.png";